import Vue from 'vue';
import store from '../store/store';

Vue.directive('can', {
  bind: function (el, binding) {
    const user = store.getters['auth/user'];
    if (typeof binding.value === 'string') {
      if (!user.permissions.includes(binding.value)) {
        el.style.display = 'none';
      }
    } else {
      let i = 0;
      binding.value.map(perm => {
        if (user.permissions.includes(perm)) {
          i++;
        }
      });
      if (i === 0) {
        el.style.display = 'none';
      }
    }
  }
});
